import { render, staticRenderFns } from "./TrainingcaseSimple.vue?vue&type=template&id=e7d0b4f2&"
import script from "./TrainingcaseSimple.vue?vue&type=script&lang=js&"
export * from "./TrainingcaseSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports